import React from 'react';

type TagType = {
  tag: string;
  tagColor: string;
};

const CardTag = ({ tag, tagColor }: TagType) => {
  const customClassName = () => {
    switch (tagColor) {
      case 'orange':
        return 'inline-block bg-gradient-to-br from-pink-500 to-orange-400 rounded-full px-3 py-1 text-sm  text-mainWhite';

      case 'sky':
        return 'inline-block bg-gradient-to-br from-sky-500 via-sky-400 to-sky-300 rounded-full px-3 py-1 text-sm  text-mainWhite';

      case 'yellow':
        return 'inline-bloc bg-gradient-to-br from-amber-500 via-amber-400  bg-amber-300 rounded-full px-3 py-1 text-sm  text-mainWhite';

      case 'blue':
        return 'inline-block bg-gradient-to-br from-blue-600 via-blue-500 to-blue-400 rounded-full px-3 py-1 text-sm  text-mainWhite';

      case 'purple':
        return 'inline-block bg-gradient-to-br from-purple-600 to-blue-500 rounded-full px-3 py-1 text-sm  text-mainWhite';

      case 'green':
        return 'inline-block bg-gradient-to-br from-emerald-500 to-teal-300 rounded-full px-3 py-1 text-sm  text-mainWhite';

      case 'pink':
        return 'inline-block bg-gradient-to-br from-pink-600 via-pink-500 to-pink-400 rounded-full px-3 py-1 text-sm  text-mainWhite';

      case 'cyan':
        return 'inline-block bg-gradient-to-br from-cyan-600 via-cyan-500 to-cyan-400 rounded-full px-3 py-1 text-sm  text-mainWhite';

      case 'silver':
        return 'inline-block bg-gradient-to-br from-white via-slate-100 to-slate-50 rounded-full px-3 py-1 text-sm text-black';

      case 'light-blue':
        return 'inline-block bg-gradient-to-br from-sky-300 via-sky-400 to-teal-500 rounded-full px-3 py-1 text-sm  text-white';

      default:
        return 'inline-block bg-mainWhite rounded-full px-3 py-1 text-sm  text-deepBlack';
    }
  };

  return <span className={customClassName()}>{tag}</span>;
};

export default CardTag;
